import { render, staticRenderFns } from "./ImageData.vue?vue&type=template&id=af64750c&scoped=true"
import script from "./ImageData.vue?vue&type=script&lang=js"
export * from "./ImageData.vue?vue&type=script&lang=js"
import style0 from "./ImageData.vue?vue&type=style&index=0&id=af64750c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af64750c",
  null
  
)

export default component.exports